var Backbone = require('backbone');
var _ = require('underscore');

var Service = require('front/pages/Service/Service');
var SendButton = require('front/components/SendButton/SendButton');
var Discount = require('front/components/Discount/Discount');

require('./ObjectPopup.less');

module.exports = Service.extend({
    template: require('./ObjectPopup.jinja'),

    el: '.ObjectPopup',

    initialize: function (options) {
        Service.prototype.initialize.call(this, options);

        this.apiUrl = options.apiUrl;
    },

    viewsRegistration: function () {
        this.registerView('discount', new Discount());
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Object/ObjectPopup.js
// module id = 59
// module chunks = 0